import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('required_with_any', (value, others, { field }) => {
  if (others) {
    for (const other of others) {
      if (other && other !== 'false' && !value) {
        return i18n.global.t('form.missing_field', { field })
      }
    }
  }
  return true
})
